
import get from 'lodash/get';

import { setSessionId } from '@biw/client-fetch';

import { Dispatch } from 'app/types/redux';
import { auth } from 'app/config';

import * as types from './types';

export function setUserData( user: any ) {
    const accessToken = get( user, 'access_token' );
    if ( accessToken ) {
        setSessionId( accessToken );
    }
    return {
        type: types.SET_USER_DATA,
        user,
    };
}

export function userLogout() {
    return {
        type: types.USER_LOGOUT,
    };
}

export const logout = () => async ( dispatch: Dispatch, getState: any) => {
    setSessionId( null as unknown as string );
    auth.signOut();
    // await dispatch( setSessionEnd() );
    // await clientFetch( {
    //     url: '/api/v1.0/logout',
    //     type: LOG_OUT
    // } );
    // document.cookie = 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    // const userAuthType = getAuthType( getState() );

    // dispatch( userLogout() );

    // setSessionId( null );

    // sessionStorage.removeItem( 'userState' );

    // if ( userAuthType === authType.SSO ) {
    //     const clientSiteUrl = ssoSelectors.getClientSiteUrl( getState() );
    //     if ( ssoSelectors.getSSOType( getState() ) === 'sso_only' && clientSiteUrl ) {
    //         document.location.replace( clientSiteUrl );
    //     } else {
    //         dispatch( routeTo( '/logout' ) );
    //     }
    // } else {
    //     dispatch( routeTo( '/login' ) );
    // }
};
